// Les envies d'achats inutiles : elles naissent de l'argent qu'on garde sous la main.
import type { TextKey } from './fr';

export interface ImpulseItem {
  id: string;
  title: TextKey;
  text: TextKey;
  price: number;
  /** Envie d'adulte (avec un salaire) plutôt que d'étudiant. */
  adult: boolean;
}

export const IMPULSE_ITEMS: ImpulseItem[] = [
  { id: 'coque', title: 'envie.coque.title', text: 'envie.coque.text', price: 25, adult: false },
  { id: 'gadget', title: 'envie.gadget.title', text: 'envie.gadget.text', price: 30, adult: false },
  { id: 'sweat', title: 'envie.sweat.title', text: 'envie.sweat.text', price: 55, adult: false },
  { id: 'ecouteurs', title: 'envie.ecouteurs.title', text: 'envie.ecouteurs.text', price: 60, adult: false },
  { id: 'jeu', title: 'envie.jeu.title', text: 'envie.jeu.text', price: 70, adult: false },
  { id: 'baskets', title: 'envie.baskets.title', text: 'envie.baskets.text', price: 120, adult: false },
  { id: 'shopping', title: 'envie.shopping.title', text: 'envie.shopping.text', price: 150, adult: true },
  { id: 'montre', title: 'envie.montre.title', text: 'envie.montre.text', price: 220, adult: true },
  { id: 'cuisine', title: 'envie.cuisine.title', text: 'envie.cuisine.text', price: 300, adult: true },
  { id: 'tele', title: 'envie.tele.title', text: 'envie.tele.text', price: 450, adult: true },
];
